import { server_ip } from "../config";

export async function fetchProductById(_id) {
    try {
        const response = await fetch(`${server_ip}/api/products/${_id}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            }
        })

        return await response.json();
    } catch (error) {
        return { errno: 1, message: 'Unexpected error' }
    }
}

export async function fetchProducts(filter, options) {
    try {
        const response = await fetch(`${server_ip}/api/products/fetch`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                filter,
                options
            })
        })

        return await response.json();
    } catch (error) {
        return { errno: 1, message: 'Unexpected error' }
    }
}
export async function insertProduct(token, data) {
    try {
        const response = await fetch(`${server_ip}/api/products`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                data
            })
        })

        return await response.json();
    } catch (error) {
        return { errno: 1, message: 'Unexpected error' }
    }
}
export async function updateProduct(token, _id, data) {
    try {
        const response = await fetch(`${server_ip}/api/products/${_id}`, {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                data
            })
        })

        return await response.json();
    } catch (error) {
        return { errno: 1, message: 'Unexpected error' }
    }
}
export async function merchantUpdateProduct(token, _id, data) {
    try {
        const response = await fetch(`${server_ip}/api/products/merchant/${_id}`, {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                data
            })
        })

        return await response.json();
    } catch (error) {
        return { errno: 1, message: 'Unexpected error' }
    }
}

export async function deleteProduct(token, _id) {
    try {
        const response = await fetch(`${server_ip}/api/products/${_id}`, {
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        })

        return await response.json();
    } catch (error) {
        return { errno: 1, message: 'Unexpected error' }
    }
}
export async function isExceedPurchaseLimit(productId) {
    try {
        const response = await fetch(`${server_ip}/api/products/isExceedPurchaseLimit`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                productId
            })
        })
        return await response.json();
    } catch (error) {
        return { errno: 1, message: 'Unexpected error' }
    }
}